import apiClient from '../lib/apiClient'

export const paymentService = {
  async getEnrollmentInfo(groupName) {
    const response = await apiClient.get(`/api/enrollments/${groupName}`)
    return response.data.data || response.data
  },

  async createCheckout(groupId) {
    const response = await apiClient.post('/api/checkouts', { group_id: groupId })
    return response.data
  },

  async verifyPayment(sessionId) {
    const response = await apiClient.get('/api/checkouts/verify', {
      params: { session_id: sessionId },
    })
    return response.data
  },
}
